/* global angular, alert */
(function () {
  'use strict';

  // Add onto the wsLrs.cards module...
  angular.module('wsLrs.cards').controller('BookmarkletProviderCard', ['$scope', '$routeParams', '$q', '$window', '$http', 'Api', 'CardRegistry', 'User', 'CardQueryResource', 'TinCanJS', function ($scope, $routeParams, $q, $window, $http, Api, CardRegistry, User, CardQueryResource, TinCanJS) {
    var baseUrl = "https://" + $window.location.host;
    $scope.tenantUrl = baseUrl + "/app";
    var user = User.get();
    $scope.endpoint = baseUrl + "/api/organizations/" + user.organization.id + "/lrs/statements";
    /* jshint scripturl:true */

    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    $scope.userName = user.user.name;
    var persona = TinCanJS.getUserPersona(user.user);
    $http.get(Api.url("/activity-providers/bookmarklet-auth"), $scope.cardId).then(function (response) {
      var authString = response.data;
      $scope.url = "javascript:void((function(d){" + "window.rbmAuth='" + authString + "',window.rbmEndpoint='" + $scope.endpoint + "',window.rbmActor='" + encodeURIComponent(JSON.stringify(persona)) + "',window.rbmReturnUrl='" + $scope.tenantUrl + "';var%20e=d.createElement('sc'+'ript');e.setAttribute('type','text/javascript');e.setAttribute('charset','UTF-8');e.setAttribute('src','" + baseUrl + "/api/cartridges/activity-providers/assets/public/bookmarkletlogic.js');d.body.appendChild(e)})(document))";
    });
    $scope.promptText = "Drag this button to your browser's bookmarks bar";
    $scope.addBookmark = function ($event) {
      $event.preventDefault();
      if ($window.sidebar && $window.sidebar.addPanel) {
        // Mozilla Firefox Bookmark
        $window.sidebar.addPanel($scope.url, $scope.bookmark, '');
      } else if ($window.external && 'AddFavorite' in $window.external) {
        // IE Favorite
        try {
          $window.external.AddFavorite($scope.url, $scope.bookmark);
        } catch (e) {
          alert('Please right click on this link and choose "Add to Favorites..." to install the bookmarklet');
        }
      } else {
        // webkit - safari/chrome
        alert('Please drag this button to your bookmarks toolbar to install the bookmarklet');
      }
    };
  }]).controller("BookmarkletCardConfiguration", ["$scope", function ($scope) {
    $scope.cardToEdit = $scope.cardToEdit || {};
    $scope.validation = $scope.validation || {};
    var parentRules = $scope.validation.rules;
    $scope.validation.rules = function () {
      return $.extend(true, {}, parentRules(), {
        "bookmarkText": {
          "rules": {
            "required": true
          },
          "value": $scope.cardToEdit.configuration.bookmarkText
        }
      });
    };
  }]);
})();
